module.exports = __webpack_public_path__ + "static/media/043-broken tooth.a90d2a2d.svg";